import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";

interface Props {
  id: string; value: boolean | null; required: boolean; invalid: boolean; describedBy?: string;
  onChange: (value: boolean | null) => void;
}

const OPTIONS: { value: string; label: string; boolean: boolean }[] = [
  { value: "yes", label: "Yes", boolean: true },
  { value: "no", label: "No", boolean: false },
];

/** Yes/No as a segmented pair, as in the reference: the chosen option is white with darker, heavier text. Clicking it again clears the value. */
export function CaseFieldBooleanToggle({ id, value, required, invalid, describedBy, onChange }: Props) {
  const current = value == null ? "" : value ? "yes" : "no";
  return <ToggleGroupPrimitive.Root type="single" id={id} className="cr-toggle" value={current} aria-required={required} aria-invalid={invalid} aria-describedby={describedBy}
    onValueChange={(next) => onChange(next === "" ? null : next === "yes")}>
    {OPTIONS.map((option) => <ToggleGroupPrimitive.Item key={option.value} value={option.value} className="cr-toggle-item" aria-label={option.label}>{option.label}</ToggleGroupPrimitive.Item>)}
  </ToggleGroupPrimitive.Root>;
}
